import * as yup from "yup";

const AddressSchema = yup.object().shape({
	firstName: yup.string().required("First name is required"),
	lastName: yup.string().required("Last name is required"),
	dateOfBirth: yup.string().required("Date of birth is required"),
	phone: yup.string().required("Phone is required"),
	addressLine1: yup.string().required("Address is required"),
	city: yup.string().required("City is required"),
	countryId: yup.string().required("Country is required"),
	stateId: yup.string().required("State is required"),
	zipCode: yup.string().required("Zip Code is required"),
});

export const ContactSchema = yup.object().shape({
	email: yup.string().required("Email is required"),
	addNewAddress: yup.boolean(),
	address: yup.object().when("addNewAddress", {
		is: true,
		then: AddressSchema,
		otherwise: yup.object().shape({
			id: yup.string().required("Please select a address"),
		}),
	}),
});

export const addressDefaultValue = {
	id: "",
	firstName: "",
	lastName: "",
	dateOfBirth: "",
	phone: "",
	addressLine1: "",
	addressLine2: "",
	city: "",
	countryId: "",
	stateId: "",
	zipCode: "",
};

export const contactDefaultValues = {
	email: "",
	addNewAddress: false,
	address: addressDefaultValue,
};
